// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-layout-item__title {
  font-size: 13px;
  font-weight: 600;
  display: block;
}

.graph-layout-item__description {
  font-size: 11px;
  display: block;
}

.graph-layout-item__fallback-warning {
  color: var(--danger);
  margin-top: 5px;
  font-size: 11px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphLayout/GraphLayoutItem.css","webpack://./services/frontend/app/components/Graph/GraphLayout/GraphLayoutItem.css"],"names":[],"mappings":"AADA;ECEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,cAAc;AAChB","sourcesContent":[".graph-layout-item__title {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.graph-layout-item__description {\n  display: block;\n  font-size: 11px;\n}\n\n.graph-layout-item__fallback-warning {\n  display: block;\n  font-size: 11px;\n  margin-top: 5px;\n  color: var(--danger);\n}\n",".graph-layout-item__title {\n  font-size: 13px;\n  font-weight: 600;\n  display: block;\n}\n\n.graph-layout-item__description {\n  font-size: 11px;\n  display: block;\n}\n\n.graph-layout-item__fallback-warning {\n  color: var(--danger);\n  margin-top: 5px;\n  font-size: 11px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
